import React, { useState } from 'react'
import DashboardLayout from './DashboardLayout'
import DownloadButtons from '../../../components/downloadButtons/DownloadButtons';
import AllSettings from '../../../components/allSettings/AllSettings';

const CorporateSetting = () => {

    return (
        <DashboardLayout>
            <AllSettings />
        </DashboardLayout>
    )
}

export default CorporateSetting